const fnrInputTypes = {
  hexcode: "hexcode",
  currency: "currency",
  percentage: "percentage",
  email: "email",
  number: "number",
  text: "text",
  date: "date",
  phone: "phone",
  taxid: "taxid",
  password: "password",
};

export default fnrInputTypes;
